// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deposit-summary-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.deposit-summary-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1rem 1.15rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.deposit-summary-card__label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.deposit-summary-card__value {
  font-size: 1.35rem;
  font-weight: 800;
  color: var(--text);
  font-variant-numeric: tabular-nums;
}

.deposit-summary-filters {
  align-items: flex-end;
}

.deposit-summary-filter {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  flex: 1 1 140px;
  min-width: 120px;
}

.deposit-summary-filter span {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.deposit-summary-expand {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff;
  color: #0f766e;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
}

.deposit-summary-expand:hover {
  background: #f0fdfa;
}

.deposit-summary-chain-row td {
  background: #f8fafc;
  font-size: 0.9rem;
}

.deposit-summary-chain-row__label {
  color: var(--text-muted);
  font-weight: 600;
}

.deposit-summary-chain-row__label i {
  margin-right: 0.35rem;
  opacity: 0.7;
}

.deposits-error {
  margin: 0 1.25rem 1rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

@media (max-width: 900px) {
  .deposit-summary-cards {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Funds/DepositSummaryByCurrencyPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".deposit-summary-cards {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.85rem;\n  margin-bottom: 1rem;\n}\n\n.deposit-summary-card {\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 1rem 1.15rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.deposit-summary-card__label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.deposit-summary-card__value {\n  font-size: 1.35rem;\n  font-weight: 800;\n  color: var(--text);\n  font-variant-numeric: tabular-nums;\n}\n\n.deposit-summary-filters {\n  align-items: flex-end;\n}\n\n.deposit-summary-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  flex: 1 1 140px;\n  min-width: 120px;\n}\n\n.deposit-summary-filter span {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.deposit-summary-expand {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: #fff;\n  color: #0f766e;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n}\n\n.deposit-summary-expand:hover {\n  background: #f0fdfa;\n}\n\n.deposit-summary-chain-row td {\n  background: #f8fafc;\n  font-size: 0.9rem;\n}\n\n.deposit-summary-chain-row__label {\n  color: var(--text-muted);\n  font-weight: 600;\n}\n\n.deposit-summary-chain-row__label i {\n  margin-right: 0.35rem;\n  opacity: 0.7;\n}\n\n.deposits-error {\n  margin: 0 1.25rem 1rem;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 900px) {\n  .deposit-summary-cards {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
